import clsx from 'clsx';
import React, { HTMLAttributes, useEffect, useRef } from 'react';
import JsonRTE from '../../basic/jsonRTE';
interface CardContentProps extends HTMLAttributes<HTMLHeadElement> {
  className?: string;
  description?: any;
}

const CardContent = ({ className, description, ...props }: CardContentProps): JSX.Element => {
  if (!description) return <></>;
  
  const divRef = useRef<HTMLDivElement>(null);
  const [hasScrollbar, setHasScrollbar] = React.useState(false);

  useEffect(() => {
      const el = divRef.current;
      if (el) {
        setHasScrollbar(el.scrollHeight > el.clientHeight);
      }
  }, [description, className]);

  return (
    <div
      ref={divRef}    
      className={clsx('text-card-description text-sm overflow-auto lg:text-base', className)}
      {...props}
      tabIndex={hasScrollbar ? 0 : -1}
    >
      {typeof description === 'string' ? (
        description
      ) : (
        <JsonRTE linkClassName="text-secondary-300 font-medium" json={description} />
      )}
    </div>
  );
};

export default CardContent;
